import { gql } from "lib/apolloClient";
import { classMaterialsFragment } from "./ClassMaterialsFragments";
import { assignmentFragment } from "ClassRoom/modules/ClassRoomFragments";

export const createClassMaterialResourceMutation = gql`
  mutation createOrganizationResources(
    $input: OrganizationResourceGroupInput!
    $studentIds: [ID!]
    $filters: OrganizationResourceFilter
    $skipAssignedStudents: Boolean!
  ) {
    platform {
      createOrganizationResources(input: $input) {
        ...classMaterialsResourceItem
      }
      __typename
    }
  }
  ${classMaterialsFragment.classMaterialsResource}
`;

export const shareClassMaterialResourceMutation = gql`
  mutation shareClassMaterialResources(
    $input: shareClassMaterialResourcesInput!
  ) {
    platform {
      shareClassMaterialResources(input: $input)
    }
  }
`;

export const importMaterialsFromUnitPlanMutation = gql`
  mutation importOrganizationResource(
    $input: OrganizationResourceImportInput!
  ) {
    platform {
      importOrganizationResource(input: $input) {
        isSuccess
        error
      }
      __typename
    }
  }
`;

export const reorderOrganizationResourcesMutation = gql`
  mutation reorderOrganizationResource(
    $input: OrganizationResourceReorderInput!
  ) {
    platform {
      reorderOrganizationResource(input: $input)
    }
  }
`;

export const deleteOrganizationResourcesMutation = gql`
  mutation deleteOrganizationResource(
    $input: OrganizationResourceDeleteInput!
  ) {
    platform {
      deleteOrganizationResource(input: $input)
    }
  }
`;

export const updateOrganizationResourceMutation = gql`
  mutation updateOrganizationResource(
    $input: OrganizationResourceUpdateInput!
  ) {
    platform {
      updateOrganizationResource(input: $input) {
        id
      }
    }
  }
`;

export const updateAssignmentMutation = gql`
  mutation updateAssignment(
    $input: UpdateAssignmentInput!
    $studentIds: [ID!]
  ) {
    platform {
      updateAssignmentV2(input: $input) {
        response {
          ...assignmentItem
        }
        warning
      }
    }
  }
  ${assignmentFragment.assignmentFeedWithoutAssignedStudents}
`;

export const updateResourceIsNewMutation = gql`
  mutation updateResourceIsNewState($ids: [ID!]) {
    platform {
      updateResourceIsNewState(input: $ids)
    }
  }
`;
